import { ColDef, ValueFormatterParams } from "ag-grid-enterprise";
import { numberFormatter } from "./valueFormatters";

/**
 * Column definition properties for numeric columns with 2 decimal places.
 * Applies number formatting and right-aligns the cell content.
 */
export function createNumericColumnProps(decimals = 2): Partial<ColDef> {
  return {
    valueFormatter: (params: ValueFormatterParams) =>
      numberFormatter(params, decimals),
    cellStyle: { textAlign: "right" }
  };
}
